// components/Header.jsx
import React from "react";

const Header = ({ handleOpen }) => (
  <header style={{ marginBottom: 20, color: '#fff', textAlign: 'center' }}>
    <h2>"QISHLOQ XO‘JALIGINI MEXANIZATSIYALASH" fakulteti</h2>
            <h2>"TRAKTORLAR VA AVTOMOBILLAR" kafedrasi</h2>
  
        <h1 className='namelesson'>“MEVA SABZAVOTLARNI SAQLASH VA QAYTA ISHLASH TEXNOLOGIYASI”</h1>
        <h2 className='italic'>ELEKTRON DARSLIK</h2>
  
  </header>
);

export default Header;
